import _upperFirst from 'lodash.upperfirst';

function getOptionFromRole({ description }) {
  return {
    label: _upperFirst(description.toLowerCase()),
    value: description
  };
}

export function getRoles(roles) {
  return roles.map(getOptionFromRole);
}

export function getSelectedRole(role, roles) {
  if (!role || !role.name) {return null;}

  const selectedRole = roles.find(({ name }) => name === role.name);

  return selectedRole ? getOptionFromRole(selectedRole) : null;
}